import React from 'react';

export const Icons = {
  DueToday: (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.7583 24.9653L16.8829 24.8294L25.1914 16.107L25.7583 24.9653Z"
        fill="#C8F5FF"
      />
      <path
        d="M24.7704 5.94008H23.5889V3.66675H21.226V5.94008H11.7741V3.66675H9.41114V5.94008H8.22966C6.91822 5.94008 5.87851 6.96308 5.87851 8.21341L5.8667 24.1267C5.8667 25.3771 6.91822 26.4001 8.22966 26.4001H24.7704C26.07 26.4001 27.1334 25.3771 27.1334 24.1267V8.21341C27.1334 6.96308 26.07 5.94008 24.7704 5.94008ZM24.7704 24.1267H8.22966V11.6234H24.7704V24.1267Z"
        class="mainPath"
        fill="#2B6BB2"
      />
      <path d="M15.4 13.9333H11V18.3333H15.4V13.9333Z" fill="#16DC38" />
    </svg>
  ),
  DueTodayActive: (
    <svg
      width="33"
      height="33"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5481 1.74953H13.6388V0H11.8203V1.74953H4.54628V0H2.72777V1.74953H1.81851C0.809238 1.74953 0.00909255 2.53682 0.00909255 3.49907L0 15.7458C0 16.7081 0.809238 17.4953 1.81851 17.4953H14.5481C15.5483 17.4953 16.3666 16.7081 16.3666 15.7458V3.49907C16.3666 2.53682 15.5483 1.74953 14.5481 1.74953ZM14.5481 15.7458H1.81851V6.12337H14.5481V15.7458Z"
        fill="white"
      />
      <path
        d="M7.33645 7.90137H3.95026V11.2876H7.33645V7.90137Z"
        fill="#16DC38"
      />
    </svg>
  ),
  ForApproval: (
    <svg
      width="27"
      height="24"
      viewBox="0 0 27 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1178 2.53111H12.8289C12.398 1.34089 11.2693 0.479004 9.93545 0.479004C8.60158 0.479004 7.47293 1.34089 7.04198 2.53111H2.75309C1.62443 2.53111 0.700989 3.45455 0.700989 4.58321V18.9479C0.700989 20.0766 1.62443 21 2.75309 21H17.1178C18.2465 21 19.1699 20.0766 19.1699 18.9479V4.58321C19.1699 3.45455 18.2465 2.53111 17.1178 2.53111ZM9.93545 2.53111C10.4998 2.53111 10.9615 2.99283 10.9615 3.55716C10.9615 4.12148 10.4998 4.58321 9.93545 4.58321C9.37112 4.58321 8.9094 4.12148 8.9094 3.55716C8.9094 2.99283 9.37112 2.53111 9.93545 2.53111ZM11.9876 16.8958H4.80519V14.8437H11.9876V16.8958ZM15.0657 12.7916H4.80519V10.7395H15.0657V12.7916ZM15.0657 8.68741H4.80519V6.63531H15.0657V8.68741Z"
        class="mainPath"
        fill="#2B6BB2"
      />
      <path
        d="M22.7589 10.2323L15.8995 17.7231L13.5337 15.1371L12.9823 14.5343L12.4288 15.1351L11.4348 16.214L10.9682 16.7204L11.433 17.2284L15.3459 21.5055L15.8993 22.1104L16.4526 21.5055L24.8524 12.3239L25.3155 11.8176L24.8524 11.3114L23.8654 10.2325L23.3123 9.62793L22.7589 10.2323Z"
        fill="#16DC38"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  ),
  ForApprovalActive: (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2174 1.65217H9.76438C9.41742 0.693913 8.50873 0 7.43481 0C6.3609 0 5.4522 0.693913 5.10525 1.65217H1.6522C0.743509 1.65217 3.05176e-05 2.39565 3.05176e-05 3.30435V14.8696C3.05176e-05 15.7783 0.743509 16.5217 1.6522 16.5217H13.2174C14.1261 16.5217 14.8696 15.7783 14.8696 14.8696V3.30435C14.8696 2.39565 14.1261 1.65217 13.2174 1.65217ZM7.43481 1.65217C7.88916 1.65217 8.2609 2.02391 8.2609 2.47826C8.2609 2.93261 7.88916 3.30435 7.43481 3.30435C6.98046 3.30435 6.60873 2.93261 6.60873 2.47826C6.60873 2.02391 6.98046 1.65217 7.43481 1.65217ZM9.08699 13.2174H3.30438V11.5652H9.08699V13.2174ZM11.5652 9.91304H3.30438V8.26087H11.5652V9.91304ZM11.5652 6.6087H3.30438V4.95652H11.5652V6.6087Z"
        fill="white"
      />
      <path
        d="M17.6521 7.75424L12.2374 13.6674L10.4404 11.7032L9.889 11.1005L9.33547 11.7013L8.53521 12.5699L8.06865 13.0763L8.53342 13.5843L11.6837 17.0279L12.2371 17.6327L12.7905 17.0279L19.5532 9.63558L20.0163 9.12933L19.5532 8.62309L18.7586 7.7545L18.2055 7.1499L17.6521 7.75424Z"
        fill="#16DC38"
        stroke="#5081FF"
        strokeWidth="1.5"
      />
    </svg>
  ),
  ForReview: (
    <svg
      width="25"
      height="26"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2783 2.03478H12.0256C11.5983 0.854609 10.4791 0 9.15652 0C7.83391 0 6.71478 0.854609 6.28748 2.03478H2.03478C0.915652 2.03478 0 2.95043 0 4.06957V18.313C0 19.4322 0.915652 20.3478 2.03478 20.3478H16.2783C17.3974 20.3478 18.313 19.4322 18.313 18.313V4.06957C18.313 2.95043 17.3974 2.03478 16.2783 2.03478ZM9.15652 2.03478C9.71609 2.03478 10.1739 2.49261 10.1739 3.05217C10.1739 3.61174 9.71609 4.06957 9.15652 4.06957C8.59696 4.06957 8.13913 3.61174 8.13913 3.05217C8.13913 2.49261 8.59696 2.03478 9.15652 2.03478ZM11.1913 16.2783H4.06957V14.2435H11.1913V16.2783ZM14.2435 12.2087H4.06957V10.1739H14.2435V12.2087ZM14.2435 8.13913H4.06957V6.10435H14.2435V8.13913Z"
        class="mainPath"
        fill="#2B6BB2"
      />
      <path
        d="M20.9783 19.5831L20.7557 19.3434H20.7402C21.306 18.3686 21.6296 17.2374 21.6296 16.0354C21.6296 12.3838 18.6696 9.42383 15.018 9.42383C11.3664 9.42383 8.40643 12.3838 8.40643 16.0354C8.40643 19.687 11.3664 22.6469 15.018 22.6469C16.22 22.6469 17.3512 22.3234 18.326 21.7576V21.7731L18.5657 21.9957L20.6698 23.9495L21.1994 24.4413L21.7105 23.9302L22.9128 22.7279L23.4239 22.2168L22.9321 21.6872L20.9783 19.5831ZM15.018 19.3434C13.1868 19.3434 11.71 17.8666 11.71 16.0354C11.71 14.2042 13.1868 12.7274 15.018 12.7274C16.8492 12.7274 18.326 14.2042 18.326 16.0354C18.326 17.8666 16.8492 19.3434 15.018 19.3434Z"
        fill="#16DC38"
        stroke="white"
        strokeWidth="1.5"
      />
      <circle cx="15.2602" cy="16.277" r="3.05217" fill="white" />
    </svg>
  ),
  ForReviewActive: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0913 1.63636H9.67131C9.32767 0.687273 8.42767 0 7.36403 0C6.3004 0 5.4004 0.687273 5.05676 1.63636H1.63676C0.73676 1.63636 0.000396729 2.37273 0.000396729 3.27273V14.7273C0.000396729 15.6273 0.73676 16.3636 1.63676 16.3636H13.0913C13.9913 16.3636 14.7277 15.6273 14.7277 14.7273V3.27273C14.7277 2.37273 13.9913 1.63636 13.0913 1.63636ZM7.36403 1.63636C7.81403 1.63636 8.18221 2.00455 8.18221 2.45455C8.18221 2.90455 7.81403 3.27273 7.36403 3.27273C6.91403 3.27273 6.54585 2.90455 6.54585 2.45455C6.54585 2.00455 6.91403 1.63636 7.36403 1.63636ZM9.0004 13.0909H3.27312V11.4545H9.0004V13.0909ZM11.4549 9.81818H3.27312V8.18182H11.4549V9.81818ZM11.4549 6.54545H3.27312V4.90909H11.4549V6.54545Z"
        fill="white"
      />
      <path
        d="M16.6746 15.6145L16.5263 15.4547H16.3112C16.8731 14.5837 17.1987 13.5477 17.1987 12.4402C17.1987 9.36031 14.7022 6.86377 11.6223 6.86377C8.54238 6.86377 6.04584 9.36031 6.04584 12.4402C6.04584 15.5201 8.54238 18.0167 11.6223 18.0167C12.7298 18.0167 13.7658 17.6911 14.6367 17.1291V17.3442L14.7965 17.4926L16.6188 19.1847L16.9719 19.5126L17.3126 19.1719L18.3539 18.1305L18.6946 17.7898L18.3668 17.4368L16.6746 15.6145ZM11.6223 15.4547C9.95376 15.4547 8.60782 14.1087 8.60782 12.4402C8.60782 10.7717 9.95376 9.42575 11.6223 9.42575C13.2908 9.42575 14.6367 10.7717 14.6367 12.4402C14.6367 14.1087 13.2908 15.4547 11.6223 15.4547Z"
        fill="#16DC38"
        stroke="#5081FF"
      />
      <circle cx="11.6595" cy="12.4773" r="3.47727" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6591 15.9547C13.5796 15.9547 15.1364 14.3978 15.1364 12.4774C15.1364 11.5403 14.7657 10.6898 14.163 10.0645C13.7833 11.9627 12.4794 14.616 9.30951 15.0407C9.92834 15.6083 10.7533 15.9547 11.6591 15.9547Z"
        fill="#C8F5FF"
      />
    </svg>
  ),
  ChangeRequest: (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.63492 1.08571H6.37905C6.15238 0.456 5.55873 0 4.85714 0C4.15556 0 3.5619 0.456 3.33524 1.08571H1.07937C0.485714 1.08571 0 1.57429 0 2.17143V9.77143C0 10.3686 0.485714 10.8571 1.07937 10.8571H8.63492C9.22857 10.8571 9.71428 10.3686 9.71428 9.77143V2.17143C9.71428 1.57429 9.22857 1.08571 8.63492 1.08571ZM4.85714 1.08571C5.15397 1.08571 5.39682 1.33 5.39682 1.62857C5.39682 1.92714 5.15397 2.17143 4.85714 2.17143C4.56032 2.17143 4.31746 1.92714 4.31746 1.62857C4.31746 1.33 4.56032 1.08571 4.85714 1.08571ZM5.93651 8.68571H2.15873V7.6H5.93651V8.68571ZM7.55556 6.51429H2.15873V5.42857H7.55556V6.51429ZM7.55556 4.34286H2.15873V3.25714H7.55556V4.34286Z"
        fill="#2B6BB2"
      />
      <path
        d="M9.49857 6.36255C8.99592 6.00058 8.37974 5.78577 7.71104 5.78577C6.01337 5.78577 4.64282 7.16115 4.64282 8.8572C4.64282 10.5532 6.01337 11.9286 7.71104 11.9286C9.14528 11.9286 10.3386 10.9476 10.6798 9.62495C10.7185 9.47523 10.6856 9.31606 10.5909 9.19382C10.5318 9.11746 10.4526 9.06089 10.3638 9.02918C10.6013 8.99031 10.7825 8.7842 10.7825 8.53577V6.28577C10.7825 6.08354 10.6606 5.90122 10.4738 5.82383C10.287 5.74644 10.0719 5.78921 9.92891 5.93221L9.49857 6.36255ZM8.03246 9.03577H9.34147C9.2103 9.08825 9.10433 9.19522 9.05546 9.33407C8.86011 9.88917 8.33121 10.2858 7.71104 10.2858C6.92325 10.2858 6.28246 9.64498 6.28246 8.8572C6.28246 8.06941 6.92325 7.42862 7.71104 7.42862C7.92186 7.42862 8.12108 7.47567 8.30077 7.56036L7.67891 8.18221C7.53591 8.32521 7.49313 8.54027 7.57052 8.72711C7.64792 8.91395 7.83023 9.03577 8.03246 9.03577Z"
        fill="#FBBC05"
        stroke="white"
        stroke-linejoin="round"
      />
    </svg>
  ),
  MarkAsRead: (
    <svg
      width="17"
      height="17"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.70601 0.00661278C8.6745 0.011076 8.57324 0.0266972 8.48097 0.0400887C8.15917 0.086956 7.76986 0.229788 7.45706 0.417255C7.22752 0.553391 7.16901 0.604721 5.80305 1.83665C5.1752 2.39905 4.18504 3.29175 3.59769 3.82068C3.01035 4.34737 2.23173 5.05037 1.86492 5.38067C1.50036 5.71097 1.1358 6.03234 1.05479 6.09706C0.86351 6.24882 0.568713 6.55904 0.456196 6.72418C0.334676 6.90719 0.183902 7.20848 0.129894 7.38032C0.00162332 7.7865 0.0106247 7.48521 0.00162332 11.6318C-0.0028774 14.4751 0.00162332 15.4994 0.0196262 15.649C0.129894 16.4702 0.604719 17.1933 1.31358 17.6151C1.54537 17.7513 1.82891 17.8718 2.09671 17.9432L2.28124 17.9923L8.90854 17.9968C16.1277 18.0035 15.6889 18.0124 16.0984 17.8807C16.9356 17.6129 17.5792 16.9769 17.865 16.1355C18.0045 15.7204 18 15.861 18 11.7546C18 9.39559 17.991 7.95834 17.9775 7.86015C17.8785 7.175 17.5792 6.65054 16.9941 6.13723C16.8343 5.99663 15.8959 5.1575 15.2996 4.61964C15.1465 4.48351 13.9606 3.41896 12.9029 2.47047C12.4709 2.08214 11.8273 1.50412 11.4739 1.18721C11.1206 0.872532 10.7628 0.56455 10.6796 0.504293C10.3825 0.298971 9.96846 0.124895 9.5814 0.049015C9.41937 0.0155392 8.81627 -0.0134735 8.70601 0.00661278ZM9.40812 1.84334C9.47788 1.87012 9.57465 1.91922 9.62415 1.9527C9.67366 1.98618 10.306 2.53965 11.0284 3.18463C11.7485 3.82737 12.9862 4.93209 13.7761 5.63509C14.5637 6.34032 15.2095 6.92058 15.2095 6.92504C15.2095 6.92951 14.791 7.24418 14.2824 7.62135C13.7716 8.00075 12.3763 9.03628 11.1837 9.92229C9.99096 10.8083 9.0008 11.5291 8.98505 11.5225C8.95355 11.5113 2.86858 6.99646 2.81457 6.94513C2.78082 6.91612 2.48602 7.18169 7.44581 2.76059C7.81036 2.43476 8.16142 2.12455 8.22443 2.06875C8.3617 1.946 8.52373 1.85674 8.68575 1.8121C8.86353 1.763 9.23934 1.77862 9.40812 1.84334ZM3.66521 9.81293C4.66211 10.5516 5.49475 11.1743 5.5195 11.1966C5.56001 11.2346 5.506 11.2903 3.69671 13.078C2.67055 14.0912 1.82441 14.9281 1.81541 14.937C1.80416 14.946 1.79741 13.4842 1.79741 11.6876C1.79741 9.08092 1.80416 8.42924 1.82666 8.44487C1.84017 8.45826 2.6683 9.07199 3.66521 9.81293ZM16.1952 13.3168L16.1884 14.9437L14.3139 13.0891C12.7814 11.5715 12.4439 11.2279 12.4686 11.2055C12.4844 11.1899 13.3282 10.5583 14.3432 9.804L16.1884 8.43148L16.1952 10.0607C16.1974 10.9556 16.1974 12.4196 16.1952 13.3168ZM7.79461 12.8794C8.19068 13.1739 8.57099 13.4395 8.6385 13.4708C8.74651 13.5221 8.79152 13.5288 8.99855 13.5288C9.20559 13.5288 9.25059 13.5221 9.35861 13.4708C9.42612 13.4395 9.81543 13.165 10.225 12.8615L10.9654 12.3125L11.2152 12.5558C11.3502 12.6897 12.2436 13.569 13.1955 14.5085L14.9282 16.2158L9.01656 16.2181C5.76254 16.2181 3.10262 16.2136 3.10262 16.2069C3.10262 16.1757 7.03174 12.3192 7.05199 12.3303C7.06325 12.337 7.39855 12.5848 7.79461 12.8794Z"
        fill="#414A4F"
      />
    </svg>
  ),
  RecurringIcon: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1083 9.37714L17.9961 9.49995L17.907 9.22952C17.618 8.34744 17.1726 7.53439 16.5796 6.8045C16.4209 6.60845 16.0986 6.26423 15.8705 6.04668C15.6581 5.84374 14.9747 5.31737 14.7289 5.16742C13.8075 4.6054 12.87 4.25248 11.9006 4.10381C9.22188 3.69178 6.58759 4.73142 4.96104 6.84005C4.71003 7.16595 4.70884 7.16749 4.73683 7.20136C4.84452 7.33598 6.17718 8.84472 6.18692 8.84484C6.19357 8.84258 6.23974 8.76987 6.28961 8.68278C6.4272 8.4467 6.847 7.91123 7.05903 7.70296C7.75125 7.01802 8.58123 6.54993 9.50975 6.31769C9.78028 6.25045 10.3705 6.17348 10.6643 6.1685C11.231 6.15712 11.938 6.2636 12.4391 6.43305C13.7491 6.87354 14.8028 7.73925 15.4612 8.91077C15.5818 9.12429 15.7466 9.47515 15.8142 9.66501L15.8522 9.76565L14.8434 9.88193C14.2877 9.94607 13.8338 10.0025 13.833 10.0068C13.8356 10.0162 15.2316 11.4458 16.6486 12.8865C16.8343 13.0763 17.1268 13.373 17.2998 13.5505C17.4712 13.7268 17.6201 13.8686 17.631 13.8672C17.6447 13.8654 20.1634 9.43682 20.2232 9.30815C20.2328 9.28605 20.237 9.26466 20.2308 9.25991C20.2262 9.25635 19.7205 9.30979 19.1083 9.37714Z"
        fill="#414A4F"
      />
      <path
        d="M15.4392 14.1474C15.3369 14.3344 15.0771 14.7101 14.9227 14.8914C14.1919 15.7509 13.3139 16.31 12.2459 16.6021C11.7266 16.7435 10.918 16.8072 10.3576 16.7497C8.79224 16.5898 7.34252 15.7341 6.4689 14.4559C6.23235 14.1088 5.99332 13.6565 5.86237 13.3095L5.81347 13.1784L6.82345 13.0605C7.37762 12.9952 7.83154 12.9388 7.83083 12.9333C7.83096 12.9236 4.08383 9.1024 4.04835 9.07507C4.0283 9.05962 3.83524 9.39324 2.72578 11.3539C2.01102 12.6169 1.42741 13.6587 1.43001 13.6681C1.43094 13.686 1.55579 13.6739 2.98748 13.5191L3.67232 13.4437L3.71668 13.5935C3.83689 13.9863 4.03728 14.4729 4.23791 14.8538C5.14912 16.5842 6.67728 17.8966 8.5076 18.5262C10.8712 19.3378 13.5111 18.9005 15.4372 17.3794C15.9425 16.9786 16.2023 16.721 16.6236 16.1965L16.9611 15.7773L16.8909 15.6962C16.8518 15.6513 16.5356 15.2896 16.1855 14.892C15.8367 14.4929 15.5338 14.149 15.5127 14.1253C15.4751 14.0816 15.4751 14.0816 15.4392 14.1474Z"
        fill="#414A4F"
      />
    </svg>
  ),
  RecurringIconDisabled: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.1083 9.37714L17.9961 9.49995L17.907 9.22952C17.618 8.34744 17.1726 7.53439 16.5796 6.8045C16.4209 6.60845 16.0986 6.26423 15.8705 6.04668C15.6581 5.84374 14.9747 5.31737 14.7289 5.16742C13.8075 4.6054 12.87 4.25248 11.9006 4.10381C9.22188 3.69178 6.58759 4.73142 4.96104 6.84005C4.71003 7.16595 4.70884 7.16749 4.73683 7.20136C4.84452 7.33598 6.17718 8.84472 6.18692 8.84484C6.19357 8.84258 6.23974 8.76987 6.28961 8.68278C6.4272 8.4467 6.847 7.91123 7.05903 7.70296C7.75125 7.01802 8.58123 6.54993 9.50975 6.31769C9.78028 6.25045 10.3705 6.17348 10.6643 6.1685C11.231 6.15712 11.938 6.2636 12.4391 6.43305C13.7491 6.87354 14.8028 7.73925 15.4612 8.91077C15.5818 9.12429 15.7466 9.47515 15.8142 9.66501L15.8522 9.76565L14.8434 9.88193C14.2877 9.94607 13.8338 10.0025 13.833 10.0068C13.8356 10.0162 15.2316 11.4458 16.6486 12.8865C16.8343 13.0763 17.1268 13.373 17.2998 13.5505C17.4712 13.7268 17.6201 13.8686 17.631 13.8672C17.6447 13.8654 20.1634 9.43682 20.2232 9.30815C20.2328 9.28605 20.237 9.26466 20.2308 9.25991C20.2262 9.25635 19.7205 9.30979 19.1083 9.37714Z"
        fill="#E5E5E5"
      />
      <path
        d="M15.4392 14.1474C15.3369 14.3344 15.0771 14.7101 14.9227 14.8914C14.1919 15.7509 13.3139 16.31 12.2459 16.6021C11.7266 16.7435 10.918 16.8072 10.3576 16.7497C8.79224 16.5898 7.34252 15.7341 6.4689 14.4559C6.23235 14.1088 5.99332 13.6565 5.86237 13.3095L5.81347 13.1784L6.82345 13.0605C7.37762 12.9952 7.83154 12.9388 7.83083 12.9333C7.83096 12.9236 4.08383 9.1024 4.04835 9.07507C4.0283 9.05962 3.83524 9.39324 2.72578 11.3539C2.01102 12.6169 1.42741 13.6587 1.43001 13.6681C1.43094 13.686 1.55579 13.6739 2.98748 13.5191L3.67232 13.4437L3.71668 13.5935C3.83689 13.9863 4.03728 14.4729 4.23791 14.8538C5.14912 16.5842 6.67728 17.8966 8.5076 18.5262C10.8712 19.3378 13.5111 18.9005 15.4372 17.3794C15.9425 16.9786 16.2023 16.721 16.6236 16.1965L16.9611 15.7773L16.8909 15.6962C16.8518 15.6513 16.5356 15.2896 16.1855 14.892C15.8367 14.4929 15.5338 14.149 15.5127 14.1253C15.4751 14.0816 15.4751 14.0816 15.4392 14.1474Z"
        fill="#E5E5E5"
      />
    </svg>
  ),
  MoveFilesIcon: (
    <svg
      width="24"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M21.601 4.5H12.001L9.60098 2H2.40098C1.08098 2 0.0129766 3.125 0.0129766 4.5L0.000976562 19.5C0.000976562 20.875 1.08098 22 2.40098 22H21.601C22.921 22 24.001 20.875 24.001 19.5V7C24.001 5.625 22.921 4.5 21.601 4.5ZM21.601 19.5H2.40098V7H21.601V19.5Z"
          fill="#414A4F"
        />
        <path
          d="M17.001 13.08L14.921 11.16V12.12H12.881V10.08H13.841L11.921 8L10.141 10.08H11.101V12.12H9.08098V11.16L7.00098 13.08L9.08098 14.86V13.9H11.121V15.94H10.161L11.921 18L13.841 15.92H12.881V13.88H14.921V14.84L17.001 13.08Z"
          fill="#414A4F"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.000976562)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  DownloadIcon: (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.355 6.28875L8.16667 10.3162V0L5.83333 0L5.83333 10.3162L1.645 6.2775L0 7.875L7 14.625L14 7.875L12.355 6.28875ZM14 15.75L0 15.75V18H14V15.75Z"
        fill="#414A4F"
      />
    </svg>
  ),
  MailIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 10.925L2 5.5V17H11.65C11.65 17.2333 11.6708 17.4875 11.7125 17.7625C11.7542 18.0375 11.8083 18.2833 11.875 18.5H2C1.6 18.5 1.25 18.3458 0.95 18.0375C0.65 17.7292 0.5 17.3833 0.5 17V4C0.5 3.61667 0.65 3.27083 0.95 2.9625C1.25 2.65417 1.6 2.5 2 2.5H19C19.3833 2.5 19.7292 2.65417 20.0375 2.9625C20.3458 3.27083 20.5 3.61667 20.5 4V11.275C20.3167 11.175 20.0792 11.0792 19.7875 10.9875C19.4958 10.8958 19.2333 10.825 19 10.775V5.5L10.5 10.925ZM10.5 9.325L19 4H2L10.5 9.325ZM2 17V5.6V4V4.1V17Z"
        fill="#999999"
      />
      <path
        d="M20.925 21.25V21H20.675H18C16.8819 21 15.9416 20.6131 15.1643 19.8357C14.3869 19.0584 14 18.1181 14 17C14 15.8819 14.3869 14.9416 15.1643 14.1643C15.9416 13.3869 16.8819 13 18 13C19.1181 13 20.0584 13.3869 20.8357 14.1643C21.6131 14.9416 22 15.8819 22 17V17.6625C22 17.8521 21.9346 18.0024 21.7982 18.1297C21.6573 18.2612 21.4955 18.325 21.3 18.325C21.0939 18.325 20.9285 18.2597 20.7893 18.1297C20.6529 18.0024 20.5875 17.8521 20.5875 17.6625V17C20.5875 16.2846 20.3348 15.6671 19.8338 15.1615C19.3323 14.6554 18.7161 14.4 18 14.4C17.2839 14.4 16.6677 14.6554 16.1662 15.1615C15.6652 15.6671 15.4125 16.2846 15.4125 17C15.4125 17.7155 15.6654 18.3298 16.1678 18.8276C16.6696 19.3248 17.2853 19.575 18 19.575C18.3913 19.575 18.7661 19.4997 19.1224 19.349C19.3818 19.2393 19.611 19.0877 19.809 18.8954C19.9511 19.0698 20.1253 19.2136 20.33 19.3256C20.633 19.4913 20.9575 19.575 21.3 19.575C21.8378 19.575 22.3032 19.3908 22.6807 19.0228C23.059 18.6541 23.25 18.1954 23.25 17.6625V17C23.25 16.2758 23.1124 15.5919 22.8358 14.951C22.5613 14.3148 22.1875 13.759 21.7143 13.2857C21.241 12.8125 20.6852 12.4387 20.049 12.1642C19.4081 11.8876 18.7242 11.75 18 11.75C17.2758 11.75 16.5919 11.8876 15.951 12.1642C15.3148 12.4387 14.759 12.8125 14.2857 13.2857C13.8125 13.759 13.4387 14.3148 13.1642 14.951C12.8876 15.5919 12.75 16.2758 12.75 17C12.75 17.7242 12.8876 18.4081 13.1642 19.049C13.4387 19.6852 13.8125 20.241 14.2857 20.7143C14.759 21.1875 15.3148 21.5613 15.951 21.8358C16.5919 22.1124 17.2758 22.25 18 22.25H20.675H20.925V22V21.25ZM18.9494 17.9408C18.6889 18.1978 18.3774 18.325 18 18.325C17.6226 18.325 17.3111 18.1978 17.0506 17.9408C16.7909 17.6846 16.6625 17.3763 16.6625 17C16.6625 16.6139 16.792 16.2991 17.0518 16.0393C17.3126 15.7785 17.6237 15.65 18 15.65C18.3763 15.65 18.6874 15.7785 18.9482 16.0393C19.208 16.2991 19.3375 16.6139 19.3375 17C19.3375 17.3763 19.2091 17.6846 18.9494 17.9408Z"
        fill="#999999"
        stroke="#999999"
        stroke-width="0.5"
      />
    </svg>
  ),
  UploadIcon: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 11V14H2V11H0V14C0 15.1 0.9 16 2 16H14C15.1 16 16 15.1 16 14V11H14ZM3 5L4.41 6.41L7 3.83V12H9V3.83L11.59 6.41L13 5L8 0L3 5Z"
        fill="#4A67DC"
      />
    </svg>
  ),
  RecordIcon: (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H18C19.1 18 20 17.1 20 16V2C20 0.9 19.1 0 18 0ZM18 16H2V2H18V16Z"
        fill="#414A4F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.41 7.42L15.99 6L12.82 9.17L11.41 7.75L10 9.16L12.82 12L17.41 7.42Z"
        fill="#414A4F"
      />
      <path d="M8 4H3V6H8V4Z" fill="#414A4F" />
      <path d="M8 8H3V10H8V8Z" fill="#414A4F" />
      <path d="M8 12H3V14H8V12Z" fill="#414A4F" />
    </svg>
  ),
  ReplyIcon: (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 14V9.65C16.5 8.75 16.1833 7.98333 15.55 7.35C14.9167 6.71667 14.15 6.4 13.25 6.4H2.85L6.7 10.25L5.65 11.3L0 5.65L5.65 0L6.7 1.05L2.85 4.9H13.25C14.55 4.9 15.6667 5.3625 16.6 6.2875C17.5333 7.2125 18 8.33333 18 9.65V14H16.5Z"
        fill="black"
      />
    </svg>
  ),
  ReplyAllIcon: (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.9 11.8L0 5.9L5.9 0L6.975 1.075L2.15 5.9L6.975 10.725L5.9 11.8ZM18.475 14V10.1C18.475 9.1 18.15 8.275 17.5 7.625C16.85 6.975 16.025 6.65 15.025 6.65H7.4L11.475 10.725L10.4 11.8L4.5 5.9L10.4 0L11.475 1.075L7.4 5.15H15.025C16.4417 5.15 17.6208 5.62083 18.5625 6.5625C19.5042 7.50417 19.975 8.68333 19.975 10.1V14H18.475Z"
        fill="black"
      />
    </svg>
  ),
  PrintIcon: (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_335_12608" fill="white">
        <path d="M18.3637 17.7726H19.7273C20.3296 17.7708 20.9066 17.5308 21.3324 17.1049C21.7582 16.6791 21.9983 16.1021 22.0001 15.4999V6.40896C21.9983 5.80675 21.7582 5.22971 21.3324 4.80388C20.9066 4.37805 20.3296 4.13803 19.7273 4.13623H2.45461C1.8524 4.13803 1.27537 4.37805 0.849538 4.80388C0.423708 5.22971 0.183683 5.80675 0.181885 6.40896V15.4999C0.183683 16.1021 0.423708 16.6791 0.849538 17.1049C1.27537 17.5308 1.8524 17.7708 2.45461 17.7726H3.81825" />
      </mask>
      <path
        d="M19.7273 17.7726V19.7726L19.7333 19.7726L19.7273 17.7726ZM22.0001 15.4999L24.0001 15.5058V15.4999H22.0001ZM22.0001 6.40896H24.0001L24.0001 6.40298L22.0001 6.40896ZM19.7273 4.13623L19.7333 2.13623H19.7273V4.13623ZM2.45461 4.13623V2.13622L2.44864 2.13624L2.45461 4.13623ZM0.181885 6.40896L-1.81812 6.40298V6.40896H0.181885ZM0.181885 15.4999H-1.81812L-1.81811 15.5058L0.181885 15.4999ZM2.45461 17.7726L2.44864 19.7726H2.45461V17.7726ZM18.3637 19.7726H19.7273V15.7726H18.3637V19.7726ZM19.7333 19.7726C20.8639 19.7692 21.9472 19.3186 22.7466 18.5192L19.9182 15.6907C19.866 15.7429 19.7952 15.7724 19.7214 15.7726L19.7333 19.7726ZM22.7466 18.5192C23.5461 17.7197 23.9967 16.6364 24.0001 15.5058L20.0001 15.4939C19.9999 15.5677 19.9704 15.6385 19.9182 15.6907L22.7466 18.5192ZM24.0001 15.4999V6.40896H20.0001V15.4999H24.0001ZM24.0001 6.40298C23.9967 5.27241 23.5461 4.18911 22.7466 3.38967L19.9182 6.2181C19.9704 6.27032 19.9999 6.34108 20.0001 6.41493L24.0001 6.40298ZM22.7466 3.38967C21.9472 2.59023 20.8639 2.13962 19.7333 2.13624L19.7214 6.13622C19.7952 6.13644 19.866 6.16588 19.9182 6.2181L22.7466 3.38967ZM19.7273 2.13623H2.45461V6.13623H19.7273V2.13623ZM2.44864 2.13624C1.31807 2.13962 0.234763 2.59023 -0.564676 3.38967L2.26375 6.2181C2.31597 6.16588 2.38674 6.13644 2.46059 6.13622L2.44864 2.13624ZM-0.564676 3.38967C-1.36411 4.18911 -1.81473 5.27241 -1.81811 6.40298L2.18188 6.41493C2.1821 6.34108 2.21153 6.27032 2.26375 6.2181L-0.564676 3.38967ZM-1.81812 6.40896V15.4999H2.18188V6.40896H-1.81812ZM-1.81811 15.5058C-1.81473 16.6364 -1.36411 17.7197 -0.564676 18.5192L2.26375 15.6907C2.21153 15.6385 2.1821 15.5677 2.18188 15.4939L-1.81811 15.5058ZM-0.564676 18.5192C0.234763 19.3186 1.31807 19.7692 2.44864 19.7726L2.46059 15.7726C2.38674 15.7724 2.31597 15.7429 2.26375 15.6907L-0.564676 18.5192ZM2.45461 19.7726H3.81825V15.7726H2.45461V19.7726Z"
        fill="#414A4F"
        mask="url(#path-1-inside-1_335_12608)"
      />
      <path
        d="M5.20018 11.5H16.982C17.1377 11.5 17.2516 11.5538 17.3131 11.6058C17.343 11.6311 17.356 11.6518 17.3607 11.6612C17.3631 11.6659 17.3637 11.6683 17.3638 11.6686L17.3638 11.6692V19.3308L17.3638 19.3314C17.3637 19.3317 17.3631 19.3341 17.3607 19.3388C17.356 19.3482 17.343 19.3689 17.3131 19.3942C17.2516 19.4462 17.1377 19.5 16.982 19.5H5.20018C5.04445 19.5 4.93055 19.4462 4.86903 19.3942C4.83922 19.3689 4.82616 19.3482 4.82142 19.3388C4.81911 19.3341 4.8185 19.3317 4.81841 19.3314L4.81836 19.3308V11.6692L4.81841 11.6686C4.8185 11.6683 4.81911 11.6659 4.82142 11.6612C4.82616 11.6518 4.83922 11.6311 4.86903 11.6058C4.93055 11.5538 5.04445 11.5 5.20018 11.5Z"
        class="inner-path"
        stroke="#414A4F"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <mask id="path-4-inside-2_335_12608" fill="white">
        <path d="M18.3638 4.13636V2.77273C18.362 2.17052 18.122 1.59348 17.6962 1.16765C17.2703 0.741823 16.6933 0.501799 16.0911 0.5H6.09109C5.48888 0.501799 4.91184 0.741823 4.48601 1.16765C4.06018 1.59348 3.82016 2.17052 3.81836 2.77273V4.13636" />
      </mask>
      <path
        d="M18.3638 2.77273H20.3638L20.3638 2.76675L18.3638 2.77273ZM16.0911 0.5L16.0971 -1.5H16.0911V0.5ZM6.09109 0.5V-1.50001L6.08511 -1.49999L6.09109 0.5ZM3.81836 2.77273L1.81836 2.76675V2.77273H3.81836ZM20.3638 4.13636V2.77273H16.3638V4.13636H20.3638ZM20.3638 2.76675C20.3604 1.63618 19.9098 0.552878 19.1104 -0.24656L16.2819 2.58187C16.3342 2.63409 16.3636 2.70485 16.3638 2.7787L20.3638 2.76675ZM19.1104 -0.24656C18.3109 -1.046 17.2276 -1.49661 16.0971 -1.49999L16.0851 2.49999C16.159 2.50021 16.2297 2.52965 16.2819 2.58187L19.1104 -0.24656ZM16.0911 -1.5H6.09109V2.5H16.0911V-1.5ZM6.08511 -1.49999C4.95454 -1.49661 3.87124 -1.046 3.0718 -0.24656L5.90023 2.58187C5.95245 2.52965 6.02321 2.50021 6.09706 2.49999L6.08511 -1.49999ZM3.0718 -0.24656C2.27236 0.552878 1.82174 1.63618 1.81837 2.76675L5.81835 2.7787C5.81857 2.70485 5.84801 2.63409 5.90023 2.58187L3.0718 -0.24656ZM1.81836 2.77273V4.13636H5.81836V2.77273H1.81836Z"
        fill="#414A4F"
        mask="url(#path-4-inside-2_335_12608)"
      />
      <path
        d="M19.0456 8.22741C19.4221 8.22741 19.7274 7.92215 19.7274 7.54559C19.7274 7.16903 19.4221 6.86377 19.0456 6.86377C18.669 6.86377 18.3638 7.16903 18.3638 7.54559C18.3638 7.92215 18.669 8.22741 19.0456 8.22741Z"
        fill="#414A4F"
      />
    </svg>
  ),
  AddressNotFoundIcon: (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 17C16.771 17 18.657 17 19.828 15.828C21 14.657 21 12.771 21 9C21 5.229 21 3.343 19.828 2.172C18.657 1 16.771 1 13 1H9C5.229 1 3.343 1 2.172 2.172C1 3.343 1 5.229 1 9C1 12.771 1 14.657 2.172 15.828C2.825 16.482 3.7 16.771 5 16.898"
        stroke="#E86C69"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.0002 16.9999C11.7642 16.9999 10.4022 17.4999 9.15924 18.1449C7.16124 19.1819 6.16224 19.7009 5.67024 19.3699C5.17824 19.0399 5.27124 18.0149 5.45824 15.9659L5.50024 15.4999M8.87924 6.87891L11.0002 8.99991M11.0002 8.99991L13.1212 11.1209M11.0002 8.99991L13.1212 6.87891M11.0002 8.99991L8.87924 11.1209"
        stroke="#E86C69"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  ),
  FullScreenIcon: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 14.9412L6.83334 9.1665"
        stroke="#414A4F"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.9412 1L9.1665 6.77471"
        stroke="#414A4F"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.75 1H15V6.25"
        stroke="#414A4F"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.25 15H1V9.75"
        stroke="#414A4F"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  ProcessesNotifIcon: (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="64" cy="64" r="64" fill="#F4F4F4" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M83.574 48.3112C85.0589 49.5487 85.2596 51.7556 84.0221 53.2406L62.5638 78.9906C61.9342 79.746 61.016 80.2018 60.0336 80.2464C59.0512 80.2909 58.0955 79.9202 57.4001 79.2248L44.5251 66.3498C43.1583 64.983 43.1583 62.7669 44.5251 61.4001C45.892 60.0333 48.108 60.0333 49.4749 61.4001L59.6398 71.565L78.6446 48.7593C79.882 47.2744 82.089 47.0737 83.574 48.3112Z"
        fill="#5081FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M63.9167 24.5C42.1474 24.5 24.5 42.1474 24.5 63.9167C24.5 85.6859 42.1474 103.333 63.9167 103.333C85.6859 103.333 103.333 85.6859 103.333 63.9167C103.333 42.1474 85.6859 24.5 63.9167 24.5Z"
        stroke="#5081FF"
        stroke-width="6"
      />
    </svg>
  ),
  ProcessesNotifTaggedIcon: (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="64" cy="64" r="64" fill="#F4F4F4" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M83.574 48.3112C85.0589 49.5487 85.2596 51.7556 84.0221 53.2406L62.5638 78.9906C61.9342 79.746 61.016 80.2018 60.0336 80.2464C59.0512 80.2909 58.0955 79.9202 57.4001 79.2248L44.5251 66.3498C43.1583 64.983 43.1583 62.7669 44.5251 61.4001C45.892 60.0333 48.108 60.0333 49.4749 61.4001L59.6398 71.565L78.6446 48.7593C79.882 47.2744 82.089 47.0737 83.574 48.3112Z"
        fill="#5081FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.5 63.9167C27.5 43.8043 43.8043 27.5 63.9167 27.5C83.9422 27.5 100.192 43.6638 100.332 63.6563C102.438 64.4321 104.421 65.4628 106.243 66.7111C106.303 65.7873 106.333 64.8556 106.333 63.9167C106.333 40.4906 87.3428 21.5 63.9167 21.5C40.4906 21.5 21.5 40.4906 21.5 63.9167C21.5 87.3428 40.4906 106.333 63.9167 106.333C65.9643 106.333 67.9781 106.188 69.9482 105.908C68.5606 104.182 67.3808 102.283 66.4467 100.247C65.6108 100.304 64.7672 100.333 63.9167 100.333C43.8043 100.333 27.5 84.029 27.5 63.9167Z"
        fill="#5081FF"
      />
      <path
        d="M90 66C78.96 66 70 74.96 70 86C70 97.04 78.96 106 90 106H100V102H90C81.32 102 74 94.68 74 86C74 77.32 81.32 70 90 70C98.68 70 106 77.32 106 86V88.86C106 90.44 104.58 92 103 92C101.42 92 100 90.44 100 88.86V86C100 80.48 95.52 76 90 76C84.48 76 80 80.48 80 86C80 91.52 84.48 96 90 96C92.76 96 95.28 94.88 97.08 93.06C98.38 94.84 100.62 96 103 96C106.94 96 110 92.8 110 88.86V86C110 74.96 101.04 66 90 66ZM90 92C86.68 92 84 89.32 84 86C84 82.68 86.68 80 90 80C93.32 80 96 82.68 96 86C96 89.32 93.32 92 90 92Z"
        fill="#16DC38"
      />
    </svg>
  ),
  EmailsNotifIcon: (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="64" cy="64" r="64" fill="#F4F4F4" />
      <path
        d="M101 41.5C101 37.375 97.625 34 93.5 34H33.5C29.375 34 26 37.375 26 41.5V86.5C26 90.625 29.375 94 33.5 94H93.5C97.625 94 101 90.625 101 86.5V41.5ZM93.5 41.5L63.5 60.25L33.5 41.5H93.5ZM93.5 86.5H33.5V49L63.5 67.75L93.5 49V86.5Z"
        fill="#5081FF"
      />
    </svg>
  ),
  EmailsNotifReplyIcon: (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="64" cy="64" r="64" fill="#F4F4F4" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M93.5 34C97.625 34 101 37.375 101 41.5V63.9124C98.6452 62.9729 96.1271 62.3554 93.5 62.1142V49L63.5 67.75L33.5 49V86.5H64.1142C64.0386 87.3232 64 88.1571 64 89C64 90.7084 64.1587 92.3797 64.4621 94H33.5C29.375 94 26 90.625 26 86.5V41.5C26 37.375 29.375 34 33.5 34H93.5ZM63.5 60.25L93.5 41.5H33.5L63.5 60.25Z"
        fill="#5081FF"
      />
      <path
        d="M105.167 96.6667C105.167 96.9428 105.391 97.1667 105.667 97.1667H109C109.276 97.1667 109.5 96.9428 109.5 96.6667V87.1381C109.5 84.1185 108.408 81.5347 106.238 79.415C104.071 77.2979 101.464 76.2333 98.4444 76.2333H76.5528L84.2399 68.6561C84.3352 68.5621 84.3889 68.4339 84.3889 68.3C84.3889 68.1661 84.3352 68.0379 84.2399 67.9439L81.9066 65.6439C81.7119 65.452 81.3992 65.452 81.2046 65.6439L68.649 78.0201C68.5537 78.1141 68.5 78.2423 68.5 78.3762C68.5 78.51 68.5537 78.6383 68.649 78.7323L81.2046 91.1085C81.3992 91.3003 81.7119 91.3003 81.9066 91.1085L84.2399 88.8085C84.3352 88.7145 84.3889 88.5862 84.3889 88.4524C84.3889 88.3185 84.3352 88.1903 84.2399 88.0963L76.5528 80.519H98.4444C100.315 80.519 101.892 81.1622 103.205 82.4561C104.517 83.7497 105.167 85.3009 105.167 87.1381V96.6667Z"
        fill="#16DC38"
        stroke="#16DC38"
        stroke-linejoin="round"
      />
    </svg>
  ),
  EmailsNotifTaggedIcon: (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="64" cy="64" r="64" fill="#F4F4F4" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M93.5 34C97.625 34 101 37.375 101 41.5V63.9124C98.6452 62.9729 96.1271 62.3554 93.5 62.1142V49L63.5 67.75L33.5 49V86.5H64.1142C64.0386 87.3232 64 88.1571 64 89C64 90.7084 64.1587 92.3797 64.4621 94H33.5C29.375 94 26 90.625 26 86.5V41.5C26 37.375 29.375 34 33.5 34H93.5ZM63.5 60.25L93.5 41.5H33.5L63.5 60.25Z"
        fill="#5081FF"
      />
      <path
        d="M89 66C77.96 66 69 74.96 69 86C69 97.04 77.96 106 89 106H99V102H89C80.32 102 73 94.68 73 86C73 77.32 80.32 70 89 70C97.68 70 105 77.32 105 86V88.86C105 90.44 103.58 92 102 92C100.42 92 99 90.44 99 88.86V86C99 80.48 94.52 76 89 76C83.48 76 79 80.48 79 86C79 91.52 83.48 96 89 96C91.76 96 94.28 94.88 96.08 93.06C97.38 94.84 99.62 96 102 96C105.94 96 109 92.8 109 88.86V86C109 74.96 100.04 66 89 66ZM89 92C85.68 92 83 89.32 83 86C83 82.68 85.68 80 89 80C92.32 80 95 82.68 95 86C95 89.32 92.32 92 89 92Z"
        fill="#16DC38"
      />
    </svg>
  ),
  FilesNotifIcon: (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="64" cy="64" r="64" fill="#F4F4F4" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M37.7958 31.7958C39.5859 30.0057 42.0138 29 44.5455 29H68.6C71.0941 29.0003 73.4894 29.9768 75.2727 31.7205L89.3995 45.5355C89.3997 45.5357 89.3994 45.5353 89.3995 45.5355C90.3087 46.4243 91.0316 47.4863 91.5249 48.6581C92.0183 49.8301 92.2726 51.0889 92.2727 52.3605V89.4545C92.2727 91.9862 91.267 94.4141 89.4769 96.2042C87.6868 97.9943 85.2589 99 82.7273 99H44.5455C42.0138 99 39.5859 97.9943 37.7958 96.2042C36.0057 94.4141 35 91.9862 35 89.4545V38.5455C35 36.0138 36.0057 33.5859 37.7958 31.7958ZM44.5455 35.3636C43.7016 35.3636 42.8923 35.6989 42.2956 36.2956C41.6989 36.8923 41.3636 37.7016 41.3636 38.5455V89.4545C41.3636 90.2984 41.6989 91.1077 42.2956 91.7044C42.8923 92.3011 43.7016 92.6364 44.5455 92.6364H82.7273C83.5711 92.6364 84.3804 92.3011 84.9772 91.7044C85.5739 91.1077 85.9091 90.2984 85.9091 89.4545V52.3613C85.9091 52.3612 85.9091 52.3614 85.9091 52.3613C85.909 51.9375 85.8242 51.5177 85.6598 51.1271C85.4954 50.7365 85.2545 50.3826 84.9514 50.0863L70.8237 36.2705C70.8236 36.2704 70.8237 36.2705 70.8237 36.2705C70.2294 35.6894 69.4312 35.3638 68.6 35.3636C68.5999 35.3636 68.6001 35.3636 68.6 35.3636H44.5455ZM50.9091 67.1818C50.9091 65.4245 52.3336 64 54.0909 64H73.1818C74.9391 64 76.3636 65.4245 76.3636 67.1818C76.3636 68.9391 74.9391 70.3636 73.1818 70.3636H54.0909C52.3336 70.3636 50.9091 68.9391 50.9091 67.1818ZM50.9091 79.9091C50.9091 78.1518 52.3336 76.7273 54.0909 76.7273H63.6364C65.3936 76.7273 66.8182 78.1518 66.8182 79.9091C66.8182 81.6664 65.3936 83.0909 63.6364 83.0909H54.0909C52.3336 83.0909 50.9091 81.6664 50.9091 79.9091Z"
        fill="#5081FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M66.8182 44.909V32.1818H73.1819V44.909C73.1819 45.7529 73.5171 46.5622 74.1138 47.1589C74.7105 47.7556 75.5198 48.0909 76.3637 48.0909H89.091V54.4545H76.3637C73.8321 54.4545 71.4042 53.4488 69.614 51.6587C67.8239 49.8686 66.8182 47.4406 66.8182 44.909Z"
        fill="#5081FF"
      />
    </svg>
  ),
  FilesNotifTaggedIcon: (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="64" cy="64" r="64" fill="#F4F4F4" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M44.5455 29C42.0138 29 39.5859 30.0057 37.7958 31.7958C36.0057 33.5859 35 36.0138 35 38.5455V89.4545C35 91.9862 36.0057 94.4141 37.7958 96.2042C39.5859 97.9943 42.0138 99 44.5455 99H65.9124C65.1092 96.9868 64.5414 94.8543 64.2428 92.6364H44.5455C43.7016 92.6364 42.8923 92.3011 42.2956 91.7044C41.6989 91.1077 41.3636 90.2984 41.3636 89.4545V38.5455C41.3636 37.7016 41.6989 36.8923 42.2956 36.2956C42.8923 35.6989 43.7016 35.3636 44.5455 35.3636H68.6C69.4312 35.3638 70.2294 35.6894 70.8237 36.2705L84.9514 50.0863C85.2545 50.3826 85.4954 50.7365 85.6598 51.1271C85.8242 51.5177 85.909 51.9375 85.9091 52.3613V62.4792C87.5578 62.1647 89.2597 62 91 62C91.4266 62 91.8509 62.0099 92.2727 62.0295V52.3605C92.2726 51.0889 92.0183 49.8301 91.5249 48.6581C91.0316 47.4863 90.3087 46.4243 89.3995 45.5355L75.2727 31.7205C73.4894 29.9768 71.0941 29.0003 68.6 29H44.5455ZM76.2603 66.3746C75.903 65.0082 74.6602 64 73.1818 64H54.0909C52.3336 64 50.9091 65.4245 50.9091 67.1818C50.9091 68.9391 52.3336 70.3636 54.0909 70.3636H71.4632C72.9004 68.8574 74.51 67.5172 76.2603 66.3746ZM66.2763 78.1324C65.7047 77.2847 64.7356 76.7273 63.6364 76.7273H54.0909C52.3336 76.7273 50.9091 78.1518 50.9091 79.9091C50.9091 81.6664 52.3336 83.0909 54.0909 83.0909H63.6364C64.0053 83.0909 64.3595 83.0281 64.689 82.9127C65.0708 81.2557 65.6051 79.6571 66.2763 78.1324Z"
        fill="#5081FF"
      />
      <path
        d="M89 68C77.96 68 69 76.96 69 88C69 99.04 77.96 108 89 108H99V104H89C80.32 104 73 96.68 73 88C73 79.32 80.32 72 89 72C97.68 72 105 79.32 105 88V90.86C105 92.44 103.58 94 102 94C100.42 94 99 92.44 99 90.86V88C99 82.48 94.52 78 89 78C83.48 78 79 82.48 79 88C79 93.52 83.48 98 89 98C91.76 98 94.28 96.88 96.08 95.06C97.38 96.84 99.62 98 102 98C105.94 98 109 94.8 109 90.86V88C109 76.96 100.04 68 89 68ZM89 94C85.68 94 83 91.32 83 88C83 84.68 85.68 82 89 82C92.32 82 95 84.68 95 88C95 91.32 92.32 94 89 94Z"
        fill="#16DC38"
      />
    </svg>
  ),
  ConverstaionNotifIcon: (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="64" cy="64" r="64" fill="#F4F4F4" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.0325 37.9986C29.0332 33.0599 33.0285 29 38 29H90C94.9557 29 99 33.0443 99 38V77C99 81.9557 94.9557 86 90 86H45.5355L33.2678 98.2678C32.5526 98.9829 31.477 99.1967 30.5426 98.8094C29.6083 98.4221 28.9994 97.51 29 96.4986L29.0325 38C29.0325 37.9995 29.0325 37.9991 29.0325 37.9986ZM38 34C35.822 34 34.0325 35.7894 34.0325 38L34.0034 90.4611L42.7322 81.7322C43.2011 81.2634 43.837 81 44.5 81H90C92.1943 81 94 79.1943 94 77V38C94 35.8057 92.1943 34 90 34H38Z"
        fill="#5081FF"
        stroke="#5081FF"
        stroke-width="2"
        stroke-linejoin="round"
      />
    </svg>
  ),
  ConverstaionNotifTaggedIcon: (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="64" cy="64" r="64" fill="#F4F4F4" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38 29C33.0285 29 29.0332 33.0599 29.0325 37.9986L29.0325 38L29 96.4986C28.9994 97.51 29.6083 98.4221 30.5427 98.8094C31.477 99.1967 32.5526 98.9829 33.2678 98.2678L45.5355 86H64.1648C64.355 84.2794 64.7069 82.6076 65.2049 81H44.5C43.837 81 43.2011 81.2634 42.7322 81.7322L34.0034 90.4611L34.0325 38C34.0325 35.7894 35.822 34 38 34H90C92.1943 34 94 35.8057 94 38V62.1648C95.7206 62.355 97.3924 62.7069 99 63.2049V38C99 33.0443 94.9557 29 90 29H38Z"
        fill="#5081FF"
      />
      <path
        d="M29.0325 37.9986L30.0325 37.9988V37.9988L29.0325 37.9986ZM29.0325 38L30.0325 38.0006L30.0325 38.0002L29.0325 38ZM29 96.4986L28 96.498L29 96.4986ZM33.2678 98.2678L33.9749 98.9749H33.9749L33.2678 98.2678ZM45.5355 86V85C45.2703 85 45.016 85.1054 44.8284 85.2929L45.5355 86ZM64.1648 86V87C64.6745 87 65.1027 86.6165 65.1587 86.1099L64.1648 86ZM65.2049 81L66.1601 81.2959C66.2541 80.9925 66.1983 80.6624 66.0098 80.4067C65.8213 80.1509 65.5226 80 65.2049 80V81ZM42.7322 81.7322L42.0251 81.0251H42.0251L42.7322 81.7322ZM34.0034 90.4611L33.0034 90.4605C33.0031 90.8651 33.2467 91.2299 33.6204 91.3849C33.9941 91.5398 34.4244 91.4543 34.7105 91.1682L34.0034 90.4611ZM34.0325 38L35.0325 38.0006V38H34.0325ZM94 62.1648H93C93 62.6745 93.3834 63.1027 93.8901 63.1587L94 62.1648ZM99 63.2049L98.7041 64.1601C99.0075 64.2541 99.3376 64.1983 99.5933 64.0098C99.8491 63.8213 100 63.5226 100 63.2049H99ZM30.0325 37.9988C30.0332 33.6051 33.5878 30 38 30V28C32.4692 28 28.0333 32.5146 28.0325 37.9985L30.0325 37.9988ZM30.0325 38.0002L30.0325 37.9988L28.0325 37.9984L28.0325 37.9998L30.0325 38.0002ZM30 96.4992L30.0325 38.0006L28.0325 37.9994L28 96.498L30 96.4992ZM30.9256 97.8857C30.365 97.6533 29.9997 97.106 30 96.4992L28 96.498C27.9992 97.914 28.8517 99.191 30.1597 99.7332L30.9256 97.8857ZM32.5607 97.5607C32.1316 97.9898 31.4862 98.118 30.9256 97.8857L30.1597 99.7332C31.4677 100.275 32.9736 99.9761 33.9749 98.9749L32.5607 97.5607ZM44.8284 85.2929L32.5607 97.5607L33.9749 98.9749L46.2426 86.7071L44.8284 85.2929ZM64.1648 85H45.5355V87H64.1648V85ZM65.1587 86.1099C65.3419 84.453 65.6807 82.8434 66.1601 81.2959L64.2497 80.7041C63.733 82.3718 63.3681 84.1059 63.1708 85.8901L65.1587 86.1099ZM44.5 82H65.2049V80H44.5V82ZM43.4393 82.4393C43.7206 82.158 44.1022 82 44.5 82V80C43.5717 80 42.6815 80.3687 42.0251 81.0251L43.4393 82.4393ZM34.7105 91.1682L43.4393 82.4393L42.0251 81.0251L33.2962 89.754L34.7105 91.1682ZM33.0325 37.9994L33.0034 90.4605L35.0034 90.4617L35.0325 38.0006L33.0325 37.9994ZM38 33C35.2644 33 33.0325 35.2424 33.0325 38H35.0325C35.0325 36.3364 36.3796 35 38 35V33ZM90 33H38V35H90V33ZM95 38C95 35.2534 92.7466 33 90 33V35C91.642 35 93 36.358 93 38H95ZM95 62.1648V38H93V62.1648H95ZM93.8901 63.1587C95.547 63.3419 97.1566 63.6807 98.7041 64.1601L99.2959 62.2497C97.6282 61.733 95.8941 61.3681 94.1099 61.1708L93.8901 63.1587ZM98 38V63.2049H100V38H98ZM90 30C94.4034 30 98 33.5966 98 38H100C100 32.492 95.508 28 90 28V30ZM38 30H90V28H38V30Z"
        fill="#5081FF"
      />
      <path
        d="M90 68C78.96 68 70 76.96 70 88C70 99.04 78.96 108 90 108H100V104H90C81.32 104 74 96.68 74 88C74 79.32 81.32 72 90 72C98.68 72 106 79.32 106 88V90.86C106 92.44 104.58 94 103 94C101.42 94 100 92.44 100 90.86V88C100 82.48 95.52 78 90 78C84.48 78 80 82.48 80 88C80 93.52 84.48 98 90 98C92.76 98 95.28 96.88 97.08 95.06C98.38 96.84 100.62 98 103 98C106.94 98 110 94.8 110 90.86V88C110 76.96 101.04 68 90 68ZM90 94C86.68 94 84 91.32 84 88C84 84.68 86.68 82 90 82C93.32 82 96 84.68 96 88C96 91.32 93.32 94 90 94Z"
        fill="#16DC38"
      />
    </svg>
  ),
  AccountNotificationIcon: (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25" cy="25" r="25" fill="#F4F4F4" />
      <path
        d="M24.9023 17.9271V12.7188H11.7188V36.1562H38.0859V17.9271H24.9023ZM16.9922 33.5521H14.3555V30.9479H16.9922V33.5521ZM16.9922 28.3438H14.3555V25.7396H16.9922V28.3438ZM16.9922 23.1354H14.3555V20.5312H16.9922V23.1354ZM16.9922 17.9271H14.3555V15.3229H16.9922V17.9271ZM22.2656 33.5521H19.6289V30.9479H22.2656V33.5521ZM22.2656 28.3438H19.6289V25.7396H22.2656V28.3438ZM22.2656 23.1354H19.6289V20.5312H22.2656V23.1354ZM22.2656 17.9271H19.6289V15.3229H22.2656V17.9271ZM35.4492 33.5521H24.9023V30.9479H27.5391V28.3438H24.9023V25.7396H27.5391V23.1354H24.9023V20.5312H35.4492V33.5521ZM32.8125 23.1354H30.1758V25.7396H32.8125V23.1354ZM32.8125 28.3438H30.1758V30.9479H32.8125V28.3438Z"
        fill="#5081FF"
      />
    </svg>
  ),
  MarkAsMisc: (
    <svg
      width="24"
      height="19"
      viewBox="0 0 24 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.118 1.86921L2.11921 1.868C2.37337 1.61341 2.64887 1.5 3 1.5H9.33579L11.2929 3.45711C11.4804 3.64464 11.7348 3.75 12 3.75H21C21.3512 3.75 21.6274 3.86347 21.8825 4.11861C22.1365 4.37264 22.25 4.64832 22.25 5V16.25C22.25 16.6014 22.1367 16.8777 21.8825 17.1325C21.6277 17.3867 21.3514 17.5 21 17.5H3C2.64832 17.5 2.37264 17.3865 2.11861 17.1325C1.86347 16.8774 1.75 16.6012 1.75 16.25V2.75C1.75 2.39887 1.86341 2.12337 2.118 1.86921Z"
        class="mainPath"
        fill="#ffffff"
        stroke="#414A4F"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M5.43922 12.6209C5.42795 12.6959 5.47303 12.7442 5.54629 12.7442H6.05344C6.10416 12.7442 6.14924 12.7013 6.15487 12.6638L6.48171 10.6317C6.48734 10.6317 6.49861 10.6317 6.49861 10.6317L7.49602 12.7388C7.51292 12.771 7.5411 12.7978 7.59181 12.7978H7.69325C7.74396 12.7978 7.77777 12.771 7.78904 12.7388L8.77518 10.6317C8.77518 10.6317 8.78645 10.6317 8.79208 10.6317L9.12455 12.6638C9.13582 12.7013 9.1809 12.7442 9.23162 12.7442H9.74441C9.81767 12.7442 9.86275 12.6959 9.84584 12.6209L9.1809 9.01792C9.17527 8.97503 9.14146 8.9375 9.07947 8.9375H8.98931C8.9386 8.9375 8.91042 8.95895 8.89352 8.99112L7.6538 11.5218C7.64817 11.5218 7.64817 11.5218 7.6369 11.5218L6.39718 8.99112C6.38028 8.95895 6.34647 8.9375 6.30138 8.9375H6.21122C6.14924 8.9375 6.11543 8.97503 6.10979 9.01792L5.43922 12.6209Z"
        fill="#414A4F"
      />
      <path
        d="M10.5895 12.6423C10.5895 12.6959 10.6403 12.7442 10.6966 12.7442H11.2207C11.277 12.7442 11.3277 12.6959 11.3277 12.6423V9.09298C11.3277 9.03937 11.277 8.99112 11.2207 8.99112H10.6966C10.6403 8.99112 10.5895 9.03937 10.5895 9.09298V12.6423Z"
        fill="#414A4F"
      />
      <path
        d="M13.3608 12.7978C14.1553 12.7978 14.6568 12.2884 14.6568 11.7362C14.6568 11.0446 14.0257 10.7336 13.4791 10.5245C13.0227 10.3476 12.8142 10.176 12.8142 9.92402C12.8142 9.72028 12.9888 9.54871 13.31 9.54871C13.62 9.54871 13.851 9.69884 14.0933 9.8436C14.1609 9.88649 14.2455 9.8436 14.2905 9.77926L14.5047 9.47365C14.5441 9.42004 14.5272 9.32889 14.4709 9.29672C14.3582 9.2163 13.9186 8.9375 13.3439 8.9375C12.4479 8.9375 12.076 9.48974 12.076 9.96691C12.076 10.5996 12.6057 10.9213 13.1354 11.125C13.6087 11.3073 13.851 11.4949 13.851 11.7684C13.851 11.9989 13.6312 12.1812 13.3382 12.1812C12.9719 12.1812 12.7184 12.015 12.4873 11.8488C12.4366 11.8113 12.3408 11.8113 12.2957 11.8863L12.0929 12.2188C12.0422 12.3045 12.0647 12.3367 12.121 12.3796C12.2845 12.5136 12.6507 12.7978 13.3608 12.7978Z"
        fill="#414A4F"
      />
      <path
        d="M15.1241 10.873C15.1241 11.9453 16.0313 12.7978 17.1584 12.7978C17.6599 12.7978 18.1445 12.6316 18.5277 12.2777C18.5671 12.2402 18.5784 12.1705 18.5333 12.133L18.1839 11.7898C18.1501 11.7577 18.0881 11.7523 18.0431 11.7898C17.8064 11.9721 17.519 12.0954 17.1809 12.0954C16.4596 12.0954 15.9186 11.5271 15.9186 10.8569C15.9186 10.1814 16.454 9.60769 17.1753 9.60769C17.4908 9.60769 17.8064 9.72564 18.0431 9.92402C18.0881 9.96691 18.1445 9.96691 18.1839 9.92402L18.5277 9.58624C18.5728 9.54335 18.5728 9.47901 18.522 9.43612C18.1389 9.10907 17.7275 8.9375 17.1584 8.9375C16.0313 8.9375 15.1241 9.8007 15.1241 10.873Z"
        fill="#414A4F"
      />
    </svg>
  ),
  ActiveEmailEntryIcon: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 7.35619C0.999979 6.87384 1.11627 6.39859 1.339 5.97074C1.56174 5.5429 1.88435 5.17507 2.2795 4.89844L6.7795 1.74844C7.28377 1.39541 7.88444 1.20605 8.5 1.20605C9.11556 1.20605 9.71623 1.39541 10.2205 1.74844L14.7205 4.89844C15.1156 5.17507 15.4383 5.5429 15.661 5.97074C15.8837 6.39859 16 6.87384 16 7.35619V13.2939C16 13.6918 15.842 14.0733 15.5607 14.3546C15.2794 14.6359 14.8978 14.7939 14.5 14.7939H2.5C2.10218 14.7939 1.72064 14.6359 1.43934 14.3546C1.15804 14.0733 1 13.6918 1 13.2939V7.35619Z"
        stroke="#5081FF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.37512 6.1687L6.62587 10.2945C7.15784 10.7201 7.81884 10.952 8.50012 10.952C9.18141 10.952 9.84241 10.7201 10.3744 10.2945L15.6251 6.1687"
        stroke="#5081FF"
        stroke-width="2"
        stroke-linejoin="round"
      />
    </svg>
  ),
  MultipleFiles: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
    >
      <path
        d="M2.506 1.22387V1.22356C2.506 0.836434 2.8194 0.52356 3.2 0.52356H7.58579C7.71839 0.52356 7.84557 0.576238 7.93934 0.670006L8.28639 0.32296L7.93934 0.670006L10.9536 3.68422C11.0473 3.77799 11.1 3.90517 11.1 4.03777V10.8236C11.1 11.2074 10.7839 11.5236 10.4 11.5236H3.194C2.81345 11.5236 2.50008 11.2108 2.5 10.8237C2.5 10.8237 2.5 10.8236 2.5 10.8236L2.503 6.02387L2.506 1.22387Z"
        stroke="#5081FF"
        stroke-linejoin="round"
      />
      <path
        d="M6 1.97668H1.2C0.54 1.97668 0.00600014 2.51668 0.00600014 3.17668L0 12.7767C0 13.4367 0.534 13.9767 1.194 13.9767H8.4C9.06 13.9767 9.6 13.4367 9.6 12.7767V5.57668L6 1.97668Z"
        fill="white"
      />
      <path
        d="M6.29289 2.26958C6.10536 2.08204 5.851 1.97668 5.58579 1.97668H1.2C0.54 1.97668 0.00600014 2.51668 0.00600014 3.17668L0 12.7767C0 13.4367 0.534 13.9767 1.194 13.9767H8.4C9.06 13.9767 9.6 13.4367 9.6 12.7767V5.9909C9.6 5.72568 9.49464 5.47133 9.30711 5.28379L6.29289 2.26958ZM7.2 11.5767H2.4V10.3767H7.2V11.5767ZM7.2 9.17668H2.4V7.97668H7.2V9.17668ZM5.4 6.17668V2.87668L8.7 6.17668H5.4Z"
        fill="#5081FF"
      />
    </svg>
  ),
  Megaphone: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.23024 12.9226C5.23024 12.9226 11.3322 13.7944 13.9473 16.4095H14.819C15.0502 16.4095 15.2719 16.3176 15.4354 16.1542C15.5989 15.9907 15.6907 15.769 15.6907 15.5378V10.2526C16.0653 10.1563 16.3973 9.93811 16.6343 9.63243C16.8714 9.32675 17 8.95092 17 8.56411C17 8.1773 16.8714 7.80147 16.6343 7.49579C16.3973 7.19011 16.0653 6.97194 15.6907 6.87561V1.59046C15.6907 1.35927 15.5989 1.13754 15.4354 0.974067C15.2719 0.81059 15.0502 0.71875 14.819 0.71875H13.9473C11.3322 3.33387 5.23024 4.20558 5.23024 4.20558H1.74341C1.28103 4.20558 0.837587 4.38926 0.510634 4.71621C0.18368 5.04316 0 5.48661 0 5.94899V11.1792C0 11.6416 0.18368 12.0851 0.510634 12.412C0.837587 12.739 1.28103 12.9226 1.74341 12.9226H2.61512L3.48683 17.2812H5.23024V12.9226ZM6.97365 5.65348C7.56903 5.52621 8.30475 5.34838 9.10062 5.11564C10.5633 4.68502 12.4218 4.0077 13.9473 2.96252V14.1648C12.4218 13.1205 10.5625 12.4432 9.10062 12.0126C8.3985 11.8074 7.68903 11.6283 6.97365 11.4756V5.65348ZM1.74341 5.94899H5.23024V11.1792H1.74341V5.94899Z"
        fill="white"
      />
    </svg>
  ),
};
